import { render, staticRenderFns } from "./dialogShowService.vue?vue&type=template&id=0dc805d8"
import script from "./dialogShowService.vue?vue&type=script&lang=js"
export * from "./dialogShowService.vue?vue&type=script&lang=js"
import style0 from "./dialogShowService.vue?vue&type=style&index=0&id=0dc805d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports